(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["happy-customers"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('panthure-happy-marquee')) {
  customElements.define('panthure-happy-marquee', class extends HTMLElement {
    connectedCallback() {
      this.initFrame = requestAnimationFrame(() => this.init());
    }

    init() {
      if (this.abort || !this.isConnected) return;
      this.viewport = this.querySelector('[data-viewport]');
      this.track = this.querySelector('[data-track]');
      if (!this.viewport || !this.track) return;
      this.abort = new AbortController();
      this.originals = Array.from(this.track.children);
      this.rotation = this.querySelector('[data-rotation]');
      this.reduced = matchMedia('(prefers-reduced-motion: reduce)');
      this.position = 0;
      this.distance = 0;
      this.frame = 0;
      this.lastTime = null;
      this.userPaused = false;
      this.selected = false;
      this.focused = false;
      this.touching = false;
      this.mediaPlaying = false;
      this.visible = true;
      this.hovered = matchMedia('(hover: hover)').matches && this.viewport.matches(':hover');
      this.speed = Math.max(1, Number(this.dataset.speed) || 40);
      this.direction = this.dataset.direction === 'right' ? -1 : 1;
      this.tick = this.tick.bind(this);
      const on = (node, event, callback, options = {}) => {
        node.addEventListener(event, callback, { ...options, signal: this.abort.signal });
      };

      on(this.rotation, 'click', () => {
        this.userPaused = !this.userPaused;
        this.rotation.textContent = this.userPaused ? 'Start billedrækken' : 'Sæt billedrækken på pause';
        this.rotation.setAttribute('aria-pressed', String(this.userPaused));
        this.sync();
      });
      on(this.viewport, 'pointerenter', event => {
        if (event.pointerType === 'touch') return;
        this.hovered = true;
        this.sync();
      });
      on(this.viewport, 'pointerleave', () => {
        this.hovered = false;
        this.sync();
      });
      on(this.viewport, 'pointerdown', event => {
        if (event.pointerType !== 'touch') return;
        this.touching = true;
        this.sync();
      }, { passive: true });
      const release = () => { this.touching = false; this.sync(); };
      on(window, 'pointerup', release, { passive: true });
      on(window, 'pointercancel', release, { passive: true });
      on(this.viewport, 'focusin', event => {
        this.focused = true;
        const slide = event.target.closest('.phc-slide');
        if (slide && !this.reduced.matches) {
          const index = this.originals.findIndex(item => item.dataset.blockId === slide.dataset.blockId);
          if (index >= 0) {
            const rect = slide.getBoundingClientRect();
            const bounds = this.viewport.getBoundingClientRect();
            if (slide.hasAttribute('data-clone') || rect.left < bounds.left || rect.right > bounds.right) {
              this.position = index * this.step;
              this.paint();
              if (slide.hasAttribute('data-clone')) {
                const target = this.originals[index].querySelector('button, video, iframe, a');
                if (target) target.focus({ preventScroll: true });
              }
            }
          }
          this.viewport.scrollLeft = 0;
        }
        this.sync();
      });
      on(this.viewport, 'focusout', () => queueMicrotask(() => {
        if (!this.abort) return;
        this.focused = this.viewport.contains(document.activeElement);
        this.sync();
      }));
      on(this.viewport, 'keydown', event => {
        if (event.target !== this.viewport || this.reduced.matches || !this.distance) return;
        if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;
        event.preventDefault();
        this.position = this.wrap(this.position + (event.key === 'ArrowRight' ? this.step : -this.step));
        this.paint();
      });
      on(this.track, 'click', event => {
        const button = event.target.closest('[data-play]');
        if (!button) return;
        const video = button.parentElement.querySelector('video');
        if (!video) return;
        video.controls = true;
        video.play().catch(() => { button.hidden = false; });
      });
      ['play', 'pause', 'ended', 'volumechange'].forEach(event => {
        on(this.track, event, () => this.syncMedia(), { capture: true });
      });
      on(this, 'shopify:block:select', event => {
        this.selected = true;
        const index = this.originals.findIndex(item => item.dataset.blockId === event.detail.blockId);
        if (index >= 0) {
          if (this.reduced.matches) this.viewport.scrollLeft = index * this.step;
          else { this.position = index * this.step; this.paint(); }
        }
        this.sync();
      });
      on(this, 'shopify:block:deselect', () => { this.selected = false; this.sync(); });
      on(document, 'visibilitychange', () => this.sync());
      on(this.reduced, 'change', () => this.build());
      on(window, 'blur', () => {
        this.focused = this.viewport.contains(document.activeElement);
        this.sync();
      });
      on(window, 'focus', () => {
        this.focused = this.viewport.contains(document.activeElement);
        this.sync();
      });

      this.resize = new ResizeObserver(() => {
        cancelAnimationFrame(this.resizeFrame);
        this.resizeFrame = requestAnimationFrame(() => this.build());
      });
      this.resize.observe(this.viewport);
      this.intersection = new IntersectionObserver(entries => {
        this.visible = entries[0].isIntersecting;
        this.sync();
      });
      this.intersection.observe(this);
      this.build();
    }

    build() {
      if (!this.abort) return;
      this.stop();
      const phase = this.distance ? this.position / this.distance : 0;
      this.track.querySelectorAll('[data-clone]').forEach(item => item.remove());
      this.classList.remove('phc-ready');
      this.track.style.transform = '';
      this.viewport.scrollLeft = 0;
      const width = this.viewport.clientWidth;
      this.distance = 0;
      this.rotation.hidden = true;
      if (!width || !this.originals.length) return;
      const styles = getComputedStyle(this);
      const columns = Math.max(1, Number(styles.getPropertyValue('--phc-columns')) || 4);
      const gap = Math.max(0, parseFloat(styles.getPropertyValue('--phc-gap')) || 0);
      const cardWidth = Math.max(1, (width - (columns - 1) * gap) / columns);
      this.style.setProperty('--phc-card-width', cardWidth + 'px');
      this.step = this.originals[0].getBoundingClientRect().width + gap;
      if (this.reduced.matches) {
        this.position = 0;
        this.syncMedia();
        return;
      }
      this.distance = this.step * this.originals.length;
      const copies = Math.ceil(width / this.distance) + 1;
      const fragment = document.createDocumentFragment();
      for (let copy = 0; copy < copies; copy++) {
        this.originals.forEach(original => {
          const clone = original.cloneNode(true);
          clone.setAttribute('data-clone', '');
          clone.setAttribute('aria-hidden', 'true');
          [clone, ...clone.querySelectorAll('*')].forEach(node => {
            node.removeAttribute('data-shopify-editor-block');
            node.removeAttribute('data-shopify-editor-section');
            if (node.id) node.id += '-copy-' + copy;
            if (node.hasAttribute('aria-controls')) {
              node.setAttribute('aria-controls', node.getAttribute('aria-controls') + '-copy-' + copy);
            }
            if (node.matches('a, button, input, select, textarea, video, iframe, [tabindex]')) {
              node.setAttribute('tabindex', '-1');
            }
          });
          clone.querySelectorAll('video').forEach(video => { video.muted = true; });
          fragment.append(clone);
        });
      }
      this.track.append(fragment);
      this.position = this.wrap(phase * this.distance);
      this.classList.add('phc-ready');
      this.rotation.hidden = false;
      this.paint();
      this.syncMedia();
    }

    syncMedia() {
      this.mediaPlaying = false;
      this.track.querySelectorAll('video').forEach(video => {
        const button = video.parentElement.querySelector('[data-play]');
        if (button) button.hidden = !video.paused && !video.ended;
        if (!video.paused && !video.ended && (!video.muted || !video.autoplay)) {
          this.mediaPlaying = true;
        }
      });
      this.sync();
    }

    wrap(value) {
      return this.distance ? ((value % this.distance) + this.distance) % this.distance : 0;
    }

    paint() {
      this.track.style.transform = 'translate3d(' + (-this.position) + 'px, 0, 0)';
    }

    canRun() {
      return this.isConnected && this.distance > 0 && !this.reduced.matches &&
        !document.hidden && this.visible && !this.userPaused && !this.selected &&
        !this.focused && !this.touching && !this.mediaPlaying &&
        !(this.dataset.pauseHover === 'true' && this.hovered);
    }

    sync() {
      if (!this.abort) return;
      if (!this.canRun()) { this.stop(); return; }
      if (!this.frame) this.frame = requestAnimationFrame(this.tick);
    }

    tick(time) {
      this.frame = 0;
      if (!this.canRun()) { this.lastTime = null; return; }
      if (this.lastTime !== null) {
        const elapsed = Math.min((time - this.lastTime) / 1000, 0.05);
        this.position = this.wrap(this.position + this.direction * this.speed * elapsed);
        this.paint();
      }
      this.lastTime = time;
      this.frame = requestAnimationFrame(this.tick);
    }

    stop() {
      cancelAnimationFrame(this.frame);
      this.frame = 0;
      this.lastTime = null;
    }

    disconnectedCallback() {
      cancelAnimationFrame(this.initFrame);
      cancelAnimationFrame(this.resizeFrame);
      this.stop();
      if (this.resize) this.resize.disconnect();
      if (this.intersection) this.intersection.disconnect();
      if (this.abort) { this.abort.abort(); this.abort = null; }
      if (this.track) {
        this.track.querySelectorAll('[data-clone]').forEach(item => item.remove());
        this.track.style.transform = '';
      }
      this.classList.remove('phc-ready');
    }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
